import React from 'react';
import { withRouter } from 'react-router';
import { Translation } from 'react-i18next';
import { Col, Row, Steps, Typography } from 'antd';

const { Title } = Typography;

const LearningAdminFormHeader = ({ id, step, steps, module }) => {
  return (
    <Translation>
      {(t) => (
        <>
          <Row justify='space-between' align='top'>
            <Col>
              <Title
                style={{ marginLeft: '24px' }}
                level={2}
                className='learning-title'
              >
                {id
                  ? t(`learning_admin_form_${module}_title_edit`)
                  : t(`learning_admin_form_${module}_title_create`)}
              </Title>
            </Col>
          </Row>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Steps
              size='small'
              current={step}
              style={{ width: steps.length === 1 ? '10%' : '50%' }}
            >
              {steps.map((step, index) => (
                <Steps.Step key={index} title={step.title} />
              ))}
            </Steps>
          </div>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminFormHeader);
